import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import ZIndex from './ZIndex';
import ClientProvider from './client';
export default createDemo(import.meta.url, ZIndex, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/system/positions/demos/z-index/ZIndex.tsx",
    "fileName": "ZIndex.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Typography from '@mui/material/Typography';\nimport Box from '@mui/material/Box';\n\nexport default function ZIndex() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 2,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <Typography\n      component=\"div\"\n      variant=\"body1\"\n      style={{\n        height: 100,\n        width: '100%',\n        position: 'relative',\n      }}\n    >\n      <Box\n        sx={(theme) => ({\n          bgcolor: 'grey.600',\n          color: 'grey.50',\n          border: '1px solid',\n          borderColor: 'grey.300',\n          p: 2,\n          borderRadius: 2,\n          fontSize: '0.875rem',\n          fontWeight: '700',\n          position: 'absolute',\n          top: 40,\n          left: '40%',\n          zIndex: 'tooltip',\n          ...theme.applyStyles('dark', {\n            bgcolor: '#101010',\n            color: 'grey.300',\n            borderColor: 'grey.800',\n          }),\n        })}\n      >\n        z-index tooltip\n      </Box>\n      <Box\n        sx={(theme) => ({\n          bgcolor: '#fff',\n          color: 'grey.800',\n          border: '1px solid',\n          borderColor: 'grey.300',\n          p: 2,\n          borderRadius: 2,\n          fontSize: '0.875rem',\n          fontWeight: '700',\n          position: 'absolute',\n          top: 0,\n          left: '43%',\n          zIndex: 'modal',\n          ...theme.applyStyles('dark', {\n            bgcolor: 'grey.800',\n            color: 'grey.300',\n            borderColor: 'grey.800',\n          }),\n        })}\n      >\n        z-index modal\n      </Box>\n    </Typography>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 63,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Typography from '@mui/material/Typography';\nimport Box from '@mui/material/Box';\n\nexport default function ZIndex() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 2
        },
        "    <Typography\n      component=\"div\"\n      variant=\"body1\"\n      style={{\n        height: 100,\n        width: '100%',\n        position: 'relative',\n      }}\n    >\n      <Box\n        sx={(theme) => ({\n          bgcolor: 'grey.600',\n          color: 'grey.50',\n          border: '1px solid',\n          borderColor: 'grey.300',\n          p: 2,\n          borderRadius: 2,\n          fontSize: '0.875rem',\n          fontWeight: '700',\n          position: 'absolute',\n          top: 40,\n          left: '40%',\n          zIndex: 'tooltip',\n          ...theme.applyStyles('dark', {\n            bgcolor: '#101010',\n            color: 'grey.300',\n            borderColor: 'grey.800',\n          }),\n        })}\n      >\n        z-index tooltip\n      </Box>\n      <Box\n        sx={(theme) => ({\n          bgcolor: '#fff',\n          color: 'grey.800',\n          border: '1px solid',\n          borderColor: 'grey.300',\n          p: 2,\n          borderRadius: 2,\n          fontSize: '0.875rem',\n          fontWeight: '700',\n          position: 'absolute',\n          top: 0,\n          left: '43%',\n          zIndex: 'modal',\n          ...theme.applyStyles('dark', {\n            bgcolor: 'grey.800',\n            color: 'grey.300',\n            borderColor: 'grey.800',\n          }),\n        })}\n      >\n        z-index modal\n      </Box>\n    </Typography>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "totalLines": 63,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "@mui/material/Typography",
      "@mui/material/Box"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
